(function () {
  'use strict';

  if (window.__GYMMONKY_TRACKING_V1__) return;
  window.__GYMMONKY_TRACKING_V1__ = true;

  var VERSION = '1.1.3';
  var scrollMilestones = [25, 50, 75, 90];
  var reachedScroll = {};
  var maxScrollPercent = 0;
  var articleReadSent = false;
  var articleActiveSeconds = 0;
  var scrollTicking = false;

  function cleanText(value, maxLength) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    return text.slice(0, maxLength || 120);
  }

  function safeUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.href);
      return cleanText(url.origin + url.pathname, 240);
    } catch (e) {
      return cleanText(value, 240);
    }
  }

  function pagePayload() {
    return {
      tracking_version: VERSION,
      page_path: window.location.pathname,
      page_title: cleanText(document.title, 140)
    };
  }

  function emit(name, params) {
    if (window.__gmAnalyticsConsent !== true) return;

    var payload = Object.assign(pagePayload(), params || {});

    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        var result = window.Shopify.analytics.publish('gymmonky:' + name, payload);
        if (result && typeof result.catch === 'function') {
          result.catch(function () {});
        }
      }
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      }
    } catch (e) {}
  }

  function socialPlatform(href) {
    if (!href) return '';
    try {
      var host = new URL(href, window.location.href).hostname.toLowerCase();
      if (host.indexOf('instagram.com') !== -1) return 'instagram';
      if (host.indexOf('tiktok.com') !== -1) return 'tiktok';
      if (host.indexOf('linkedin.com') !== -1) return 'linkedin';
      if (host.indexOf('youtube.com') !== -1 || host.indexOf('youtu.be') !== -1) return 'youtube';
      if (host.indexOf('facebook.com') !== -1 || host.indexOf('fb.com') !== -1) return 'facebook';
    } catch (e) {}
    return '';
  }

  function navLocation(link) {
    if (!link) return '';
    if (link.closest('footer, .footer-group, [id*="shopify-section-footer"]')) return 'footer';
    if (link.closest('.drawer, .drawer__submenu, .drawer__menu-item, [id*="Drawer"]')) return 'mobile';
    if (link.closest('header, .header-group, [id*="shopify-section-header"]')) return 'header';
    return '';
  }

  function internalPath(href) {
    if (!href) return '';
    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return '';
      return url.pathname + (url.hash || '');
    } catch (e) {
      return '';
    }
  }

  function inferBundle(element) {
    if (!element) return '';
    var raw = [
      element.getAttribute('data-gm-bundle'),
      element.getAttribute('data-bundle'),
      element.getAttribute('data-type'),
      element.getAttribute('data-url'),
      element.getAttribute('href'),
      element.getAttribute('title'),
      element.getAttribute('aria-label'),
      element.textContent
    ].join(' ').toLowerCase();

    if (/(^|[^0-9])3\s*(er|pack|clip|case|bundle)/.test(raw) || /set[-_ ]?3/.test(raw) || /case[-_ ]?set[-_ ]?3/.test(raw)) return '3';
    if (/(^|[^0-9])2\s*(er|pack|clip|case|bundle)/.test(raw) || /set[-_ ]?2/.test(raw) || /case[-_ ]?set[-_ ]?2/.test(raw)) return '2';
    if (/(^|[^0-9])1\s*(er|pack|clip|case|bundle)/.test(raw) || /set[-_ ]?1/.test(raw) || /case[-_ ]?set[-_ ]?1/.test(raw)) return '1';
    return '';
  }

  function inferColor(element) {
    if (!element) return '';
    var raw = [
      element.getAttribute('title'),
      element.getAttribute('aria-label'),
      element.getAttribute('data-value'),
      element.getAttribute('data-option-value'),
      element.getAttribute('value'),
      element.textContent
    ].join(' ').toLowerCase();

    var colors = [
      ['Core Black', 'core black'],
      ['Power Red', 'power red'],
      ['Steel Grey', 'steel grey'],
      ['Steel Grey', 'steel gray'],
      ['Electric Pink', 'electric pink'],
      ['Sky Blue', 'sky blue']
    ];

    for (var i = 0; i < colors.length; i++) {
      if (raw.indexOf(colors[i][1]) !== -1) return colors[i][0];
    }
    return '';
  }

  function elementLabel(element) {
    if (!element) return '';
    return cleanText(
      element.getAttribute('aria-label') ||
      element.getAttribute('title') ||
      element.textContent ||
      '',
      100
    );
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('a[href]');
    var social = link ? socialPlatform(link.href) : '';

    if (social) {
      emit('social_outbound_click', {
        social_platform: social,
        link_url: safeUrl(link.href),
        link_text: elementLabel(link),
        link_location: navLocation(link) || 'content'
      });
    }

    if (link && !social) {
      var locationName = navLocation(link);
      var path = internalPath(link.href);
      if (locationName && path && path !== '#') {
        emit('nav_click', {
          nav_location: locationName,
          link_path: cleanText(path, 180),
          link_text: elementLabel(link)
        });
      }
    }

    var summary = target.closest('summary');
    if (summary) {
      var details = summary.closest('details');
      if (details && details.closest('.faq, [id*="faq"], [class*="faq"]')) {
        setTimeout(function () {
          if (details.open) {
            emit('faq_expand', {
              faq_question: elementLabel(summary)
            });
          }
        }, 0);
      }
    }

    var bundleElement = target.closest('.ank-bundle-item, [data-gm-bundle], [data-bundle], a[href], button');
    var bundle = inferBundle(bundleElement);
    if (bundle) {
      emit('bundle_select', {
        bundle_size: bundle,
        element_text: elementLabel(bundleElement),
        target_path: bundleElement && bundleElement.href ? internalPath(bundleElement.href) : ''
      });
    }

    var colorElement = target.closest('.gmu-sw, .swatch-anchor, [data-value], [data-option-value], [title], [aria-label]');
    var color = inferColor(colorElement);
    if (color) {
      emit('color_select', {
        color_name: color,
        element_text: elementLabel(colorElement)
      });
    }

    var cta = target.closest('a.button, a[class*="button"], a.hero-btn, button.button, button[class*="button"]');
    if (cta && !cta.closest('header, footer, .header-group, .footer-group')) {
      var href = cta.tagName === 'A' ? (cta.getAttribute('href') || '') : '';
      var isWaitlist = href.indexOf('#open-waitlist') !== -1;
      var isCartButton = cta.matches('[name="add"], [type="submit"], .product-form__submit');
      if (!isWaitlist && !isCartButton && !social && !bundle) {
        emit('cta_click', {
          cta_text: elementLabel(cta),
          target_path: href ? internalPath(href) : ''
        });
      }
    }
  }

  function videoInfo(video) {
    var src =
      video.currentSrc ||
      video.getAttribute('src') ||
      (video.querySelector('source') ? video.querySelector('source').getAttribute('src') : '') ||
      '';

    var section = video.closest('.shopify-section');
    var heading = section ? section.querySelector('h1, h2, h3') : null;
    var name =
      video.getAttribute('aria-label') ||
      video.getAttribute('title') ||
      (heading ? heading.textContent : '') ||
      (src ? src.split('/').pop().split('?')[0] : 'video');

    return {
      video_name: cleanText(name, 120),
      video_url: safeUrl(src),
      video_autoplay: !!video.autoplay,
      video_muted: !!video.muted
    };
  }

  function attachVideo(video) {
    if (!video || video.dataset.gmTrackingBound === '1') return;
    video.dataset.gmTrackingBound = '1';
    video.dataset.gmVideoProgress = '';

    video.addEventListener('play', function () {
      if (video.dataset.gmVideoStarted === '1') return;
      video.dataset.gmVideoStarted = '1';
      emit('video_start', videoInfo(video));
    });

    video.addEventListener('timeupdate', function () {
      if (!video.duration || !isFinite(video.duration)) return;
      var percent = Math.floor((video.currentTime / video.duration) * 100);
      var sent = video.dataset.gmVideoProgress ? video.dataset.gmVideoProgress.split(',') : [];
      [25, 50, 75, 90].forEach(function (milestone) {
        if (percent >= milestone && sent.indexOf(String(milestone)) === -1) {
          sent.push(String(milestone));
          video.dataset.gmVideoProgress = sent.join(',');
          emit('video_progress', Object.assign(videoInfo(video), {
            video_percent: milestone
          }));
        }
      });
    });

    video.addEventListener('ended', function () {
      if (video.dataset.gmVideoComplete === '1') return;
      video.dataset.gmVideoComplete = '1';
      emit('video_complete', videoInfo(video));
    });
  }

  function attachVideos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video').forEach(attachVideo);
  }

  function currentScrollPercent() {
    var doc = document.documentElement;
    var body = document.body;
    var scrollTop = window.pageYOffset || doc.scrollTop || (body ? body.scrollTop : 0) || 0;
    var viewport = window.innerHeight || doc.clientHeight || 0;
    var fullHeight = Math.max(
      doc.scrollHeight,
      body ? body.scrollHeight : 0,
      doc.offsetHeight,
      body ? body.offsetHeight : 0
    );
    if (fullHeight <= viewport) return 100;
    return Math.min(100, Math.round(((scrollTop + viewport) / fullHeight) * 100));
  }

  function evaluateScroll() {
    scrollTicking = false;
    var percent = currentScrollPercent();
    if (percent > maxScrollPercent) maxScrollPercent = percent;

    scrollMilestones.forEach(function (milestone) {
      if (percent >= milestone && !reachedScroll[milestone]) {
        reachedScroll[milestone] = true;
        emit('scroll_depth', {
          scroll_percent: milestone
        });
      }
    });

    maybeSendArticleRead();
  }

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(evaluateScroll);
  }

  function isArticlePage() {
    var bodyClass = document.body ? document.body.className : '';
    return bodyClass.indexOf('template-article') !== -1 ||
      /^\/blogs\/[^/]+\/[^/]+/.test(window.location.pathname);
  }

  function maybeSendArticleRead() {
    if (!isArticlePage() || articleReadSent) return;
    if (articleActiveSeconds >= 30 && maxScrollPercent >= 75) {
      articleReadSent = true;
      emit('article_read', {
        active_seconds: articleActiveSeconds,
        max_scroll_percent: maxScrollPercent,
        read_definition: '30s_active_and_75pct'
      });
    }
  }

  function startArticleTimer() {
    if (!isArticlePage()) return;
    window.setInterval(function () {
      if (document.visibilityState === 'visible') {
        articleActiveSeconds += 1;
        maybeSendArticleRead();
      }
    }, 1000);
  }


  var waitlistFormIds = {
    XCFTiS: 'popup',
    Wqzzb2: 'embed'
  };
  var waitlistFormStarted = {};
  var lastWaitlistCta = null;

  var homepageSections = [
    ['video_with_text_xKJKJc', 'hero', 1],
    ['multicolumn_with_icons_TbHero1', 'hero_trust', 2],
    ['gm_usp_center_image_KgfRqi', 'product_benefits', 3],
    ['image_with_text_founderTrustV2', 'founder_trust', 4],
    ['multicolumn_FzjA9i', 'problem', 5],
    ['rich_text_dVXenj', 'solution_transition', 6],
    ['multicolumn_MpMFjd', 'how_it_works', 7],
    ['rich_text_9AWK7a', 'mid_waitlist_cta', 8],
    ['multicolumn_fcdHaR', 'use_cases', 9],
    ['rich_text_KgW74p', 'product_proof', 10],
    ['multicolumn_with_icons_HDefJL', 'technical_trust', 11],
    ['custom_liquid_im6UgQ', 'product_showcase', 12],
    ['faq_WNMtTy', 'faq', 13],
    ['rich_text_LTcERk', 'final_cta', 14]
  ];

  function homepageSectionData(element) {
    if (!element || typeof element.closest !== 'function') return null;
    var wrapper = element.closest('.shopify-section[id]');
    if (!wrapper) return null;
    var rawId = wrapper.id.replace(/^shopify-section-/, '');
    for (var i = 0; i < homepageSections.length; i++) {
      if (homepageSections[i][0] === rawId) {
        return {
          section_id: rawId,
          section_name: homepageSections[i][1],
          section_order: homepageSections[i][2]
        };
      }
    }
    return null;
  }

  function initHomepageSectionTracking() {
    if (!document.body || document.body.className.indexOf('template-index') === -1) return;
    if (!('IntersectionObserver' in window)) return;

    var sent = {};
    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var data = homepageSectionData(entry.target);
        if (!data || sent[data.section_id]) return;
        sent[data.section_id] = true;
        emit('section_view', data);
        sectionObserver.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0.01
    });

    homepageSections.forEach(function (definition) {
      var element = document.getElementById('shopify-section-' + definition[0]);
      if (element) sectionObserver.observe(element);
    });
  }

  function waitlistCtaLocation(element) {
    if (element && element.getAttribute) {
      var explicitLocation = element.getAttribute('data-gm-waitlist-location');
      if (explicitLocation) return explicitLocation;
    }
    var section = homepageSectionData(element);
    if (section) return section.section_name;
    return navLocation(element) || 'content';
  }

  function handleWaitlistCtaClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest('a[href="#open-waitlist"], a[href$="#open-waitlist"], [data-gm-waitlist="true"]');
    if (!link) return;

    var locationName = waitlistCtaLocation(link);
    lastWaitlistCta = {
      time: Date.now(),
      location: locationName
    };

    emit('waitlist_cta_click', {
      form_id: 'XCFTiS',
      cta_location: locationName,
      cta_text: elementLabel(link),
      target_path: '#open-waitlist'
    });
  }

  function currentWaitlistOpenSource() {
    if (lastWaitlistCta && Date.now() - lastWaitlistCta.time <= 5000) return 'cta';
    return 'automatic';
  }

  function handleKlaviyoFormEvent(event) {
    var detail = event && event.detail ? event.detail : {};
    var formId = detail.formId || '';
    if (!waitlistFormIds[formId]) return;

    var common = {
      form_id: formId,
      form_type: waitlistFormIds[formId]
    };

    if (detail.type === 'open' || detail.type === 'embedOpen') {
      common.open_source = detail.type === 'embedOpen' ? 'embed' : currentWaitlistOpenSource();
      if (common.open_source === 'cta' && lastWaitlistCta) {
        common.cta_location = lastWaitlistCta.location;
      }
      emit('waitlist_form_open', common);
      return;
    }

    if (detail.type === 'close') {
      emit('waitlist_form_close', common);
      return;
    }

    if (detail.type === 'submit') {
      common.list_id = 'ST5DRt';
      emit('waitlist_signup', common);
    }
  }

  function klaviyoFormIdFromElement(element) {
    if (!element || typeof element.closest !== 'function') return '';
    var root = element.closest('[class*="klaviyo-form-"]');
    if (!root) return '';
    var className = typeof root.className === 'string' ? root.className : '';
    var match = className.match(/klaviyo-form-([A-Za-z0-9]+)/);
    return match ? match[1] : '';
  }

  function handleWaitlistFormStart(event) {
    var target = event.target;
    if (!target || !/^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)) return;
    var formId = klaviyoFormIdFromElement(target);
    if (!waitlistFormIds[formId] || waitlistFormStarted[formId]) return;
    waitlistFormStarted[formId] = true;
    emit('waitlist_form_start', {
      form_id: formId,
      form_type: waitlistFormIds[formId]
    });
  }

  if (!window.gmWaitlistOpenReady) {
    window.gmWaitlistOpenReady = true;
    document.addEventListener('click', function(event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var link = target.closest('a[href="#open-waitlist"], a[href$="#open-waitlist"], [data-gm-waitlist="true"]');
      if (!link) return;
      event.preventDefault();
      var attempts = 0;
      var openForm = function() {
        if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
          window.klaviyo.openForm('XCFTiS');
          return;
        }
        attempts += 1;
        if (attempts < 20) window.setTimeout(openForm, 100);
      };
      openForm();
    });
  }

  document.addEventListener('click', handleWaitlistCtaClick, true);
  document.addEventListener('focusin', handleWaitlistFormStart, true);
  window.addEventListener('klaviyoForms', handleKlaviyoFormEvent);
    document.addEventListener('click', handleClick, true);

  window.addEventListener('scroll', onScroll, { passive: true });

  attachVideos(document);
  initHomepageSectionTracking();

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        if (node.tagName === 'VIDEO') attachVideo(node);
        attachVideos(node);
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
      attachVideos(document);
    }, { once: true });
  }

  startArticleTimer();
})();